module.exports = __webpack_public_path__ + "media/images/flags/ms-1db1eb78abd429aa482d1d45dfa54a06.svg";